import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Leadership() {
  const { t } = useLanguage();
  const leaders = t("leadership.list");

  return (
    <section id="leadership" className="py-28 md:py-40" data-testid="leadership-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="04" title={t("chapters.leadership")} />
        <FadeUp>
          <h2 className="mb-14 max-w-3xl text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem] md:mb-20" data-testid="leadership-heading">
            {t("leadership.headingA")} <span className="text-[#F97316]">{t("leadership.headingB")}</span>
          </h2>
        </FadeUp>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {leaders.map((l, i) => (
            <FadeUp
              key={l.name}
              delay={i * 0.1}
              className="group rounded-2xl border border-white/10 bg-[#111111] p-8 transition-colors duration-500 hover:border-[#F97316]/50 md:p-10"
              data-testid={`leader-card-${i + 1}`}
            >
              <div className="flex items-start gap-6 md:gap-8">
                <div className="h-36 w-28 shrink-0 overflow-hidden rounded-xl bg-gradient-to-b from-[#F97316] to-[#9a3412] shadow-lg shadow-black/40 ring-1 ring-white/10 md:h-44 md:w-36">
                  <img
                    src={l.img}
                    alt={`${l.name} — ${l.role}`}
                    loading="lazy"
                    className="h-full w-full object-contain object-bottom transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  />
                </div>
                <div>
                  <h3 className="font-syne text-xl font-bold tracking-tight transition-colors duration-300 group-hover:text-[#F97316] md:text-2xl">
                    {l.name}
                  </h3>
                  <p className="mt-1.5 font-spacemono text-[10px] uppercase tracking-[0.3em] text-[#F97316]/80">{l.role}</p>
                  <p className="mt-5 text-sm leading-relaxed text-white/55">{l.intro}</p>
                </div>
              </div>
              <ul className="mt-8 space-y-2.5 border-t border-white/10 pt-7">
                {l.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-3 text-sm leading-relaxed text-white/60">
                    <span className="mt-2 h-1 w-1 shrink-0 bg-[#F97316]" />
                    {pt}
                  </li>
                ))}
              </ul>
              <p className="mt-7 border-t border-white/10 pt-5 font-spacemono text-[10px] uppercase tracking-[0.25em] text-white/35">
                {t("leadership.notable")}
                {l.clients}
              </p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
